import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';

import PageRestrictionsContextQuery, {
	type PageRestrictionsContextQuery$data as Q,
	type PageRestrictionsContextQuery$variables as V,
} from './__generated__/PageRestrictionsContextQuery.graphql.ts';
import { ALLOWED_CONTENT_STATUSES } from './constants.ts';
import type { GraphQLErrorPayload as GraphQLErrorInterop } from '@confluence/relay-errors/entry-points/RelayError.ts';

export function preloadPageRestrictionsQuery(
	contentId: V['contentId'],
	includeAncestors: boolean,
): Promise<{
	data: Q | null;
	errors?: ReadonlyArray<GraphQLErrorInterop>;
	hasErrors: boolean;
}> {
	return query<Q, V>({
		query: PageRestrictionsContextQuery,
		variables: {
			contentId,
			status: ALLOWED_CONTENT_STATUSES,
			includeAncestors,
		},
		// Preloaders are called both on server at initial load AND transition on client-side.
		// On server-side it doesn't matter fetch policy because we only gonna request once.
		// On client-side it must be network-only to get fresh data.
		fetchPolicy: 'network-only',
	});
}
